/*
  8COM Wishlist - central store, v3.

  v3 changes:
    - Product-card detection now REQUIRES a price inside the card, so
      hero / slideshow banners that link to a product no longer get a
      heart (verified on the live homepage: 224 real cards kept,
      6 slideshow banners rejected).
    - Uses the supplied si_heart-line icon artwork.

  v2 changes:
    - Products match on handle OR id, so hearts created by different
      sources all refer to the same saved product.
    - Automatic heart injection across the whole site.

  Public API (window.Wishlist8com):
    getWishlist() / isWishlisted(p) / addToWishlist(p)
    removeFromWishlist(p) / toggleWishlist(p) / count() / clear()

  Emits 'wishlist:updated' with detail = { items, id, handle, saved }.
  Disable auto-injection with: window.WISHLIST_AUTO_INJECT = false;
*/
(function () {
  'use strict';

  var KEY = '8com_wishlist';
  var EVENT = 'wishlist:updated';
  var MAX_ITEMS = 250;
  var AUTO = window.WISHLIST_AUTO_INJECT !== false;

  /*
    Regions that must never receive a heart. Beyond the obvious chrome,
    this excludes the "Frequently Bought Together" bundle widget
    (.ai-fbt-* and .fbt-rebuilt-*), whose tiles do show a price and so
    would otherwise pass the
    product-card test, and whose own checkbox control the heart overlapped.
  */
  var BLOCKED = [
    'header', 'nav', 'footer', '.header', '.footer',
    '.announcement-bar', '.cart-drawer', '.predictive-search',
    '[class*="ai-fbt-"]',
    '[class*="fbt-rebuilt"]',
    '[class*="bundle"]',
    '[class*="together"]',
    '[class*="slideshow"]', '[class*="-banner"]', '[class*="hero-"]'
  ].join(', ');
  var MONEY = /(?:[\u00a3$\u20ac]|GBP|USD|EUR|AED|SAR)\s?\d/;

  /* ---------------- storage ---------------- */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (i) { return i && (i.id || i.handle); }).map(function (i) {
        return {
          id: i.id ? String(i.id) : '',
          handle: i.handle ? String(i.handle) : '',
          addedAt: i.addedAt || Date.now()
        };
      });
    } catch (e) { return []; }
  }

  function write(items) {
    try { window.localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX_ITEMS))); }
    catch (e) { /* quota or private mode */ }
  }

  function same(item, product) {
    if (!item || !product) return false;
    if (product.id && item.id && String(item.id) === String(product.id)) return true;
    if (product.handle && item.handle && item.handle === product.handle) return true;
    return false;
  }

  function normalise(product) {
    if (typeof product === 'string' || typeof product === 'number') {
      return { id: String(product), handle: '' };
    }
    return {
      id: product && product.id ? String(product.id) : '',
      handle: product && product.handle ? String(product.handle) : ''
    };
  }

  /* ---------------- core api ---------------- */

  function getWishlist() { return read(); }

  function isWishlisted(product) {
    var t = normalise(product);
    if (!t.id && !t.handle) return false;
    return read().some(function (i) { return same(i, t); });
  }

  function addToWishlist(product) {
    var t = normalise(product);
    if (!t.id && !t.handle) return read();
    var items = read();
    var found = false;
    items = items.map(function (i) {
      if (!same(i, t)) return i;
      found = true;
      return { id: i.id || t.id, handle: i.handle || t.handle, addedAt: i.addedAt };
    });
    if (!found) items.unshift({ id: t.id, handle: t.handle, addedAt: Date.now() });
    write(items);
    return items;
  }

  function removeFromWishlist(product) {
    var t = normalise(product);
    if (!t.id && !t.handle) return read();
    var items = read().filter(function (i) { return !same(i, t); });
    write(items);
    return items;
  }

  function toggleWishlist(product) {
    var t = normalise(product);
    if (!t.id && !t.handle) return false;
    var saved = !isWishlisted(t);
    if (saved) { addToWishlist(t); } else { removeFromWishlist(t); }
    emit(t, saved);
    return saved;
  }

  function count() { return read().length; }

  function clear() { write([]); emit({ id: '', handle: '' }, false); }

  function emit(t, saved) {
    document.dispatchEvent(new CustomEvent(EVENT, {
      bubbles: true,
      detail: { items: read(), id: t.id, handle: t.handle, saved: saved }
    }));
  }

  /* ---------------- dom ---------------- */

  function productFromButton(btn) {
    return {
      id: btn.getAttribute('data-product-id') || btn.getAttribute('product-id') || '',
      handle: btn.getAttribute('data-product-handle') || btn.getAttribute('product-handle') || ''
    };
  }

  /* Supplied icon artwork (si_heart-line). */
  function heartSvg() {
    return '<svg class="wishlist-btn__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M16.696 3C14.652 3 12.887 4.197 12 5.943C11.113 4.197 9.348 3 7.304 3C4.374 3 2 5.457 2 8.481C2 11.505 3.817 14.277 6.165 16.554C8.513 18.831 12 21 12 21C12 21 15.374 18.867 17.835 16.554C20.46 14.088 22 11.514 22 8.481C22 5.448 19.626 3 16.696 3Z" ' +
      'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function buildButton(product) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-btn';
    btn.setAttribute('data-wishlist-toggle', '');
    if (product.id) btn.setAttribute('data-product-id', product.id);
    if (product.handle) btn.setAttribute('data-product-handle', product.handle);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.innerHTML = heartSvg();
    return btn;
  }

  function paintButton(btn, items) {
    var p = productFromButton(btn);
    if (!p.id && !p.handle) return;
    var saved = items.some(function (i) { return same(i, p); });
    btn.classList.toggle('is-active', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = saved ? 'Remove from wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }

  function hydrate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = read();
    var buttons = scope.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) paintButton(buttons[i], items);
    updateCount();
  }

  function updateCount() {
    var total = count();
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = String(total);
      nodes[i].setAttribute('data-empty', total === 0 ? 'true' : 'false');
    }
  }

  /* ---------------- automatic injection ---------------- */

  function handleFromHref(href) {
    if (!href) return '';
    var clean = href.split('?')[0].split('#')[0];
    var m = clean.match(/\/products\/([^/]+)/);
    return m ? m[1] : '';
  }

  /*
    A genuine product card must contain a PRICE. Slideshow slides, hero
    banners and collection tiles link to products but never show a price,
    so this single rule keeps hearts off them.
  */
  function hasPrice(el) {
    if (!el) return false;
    if (el.querySelector('[class*="price" i], [data-price], .money')) return true;
    return MONEY.test(el.textContent || '');
  }

  function productCard(link) {
    var el = link.parentElement;
    var steps = 0;
    while (el && el !== document.body && steps < 8) {
      if (el.tagName !== 'A' && el.offsetWidth >= 110 && el.offsetWidth <= 900 && hasPrice(el)) {
        return el;
      }
      el = el.parentElement;
      steps++;
    }
    return null;
  }

  /* Prefer sitting over the image, falling back to the card itself. */
  function anchorFor(link, card) {
    var wrap = link.parentElement;
    if (wrap && wrap.tagName !== 'A' && wrap.offsetWidth >= 100 && wrap.offsetHeight >= 100) {
      return wrap;
    }
    return card;
  }

  function autoInject(root) {
    if (!AUTO) return;

    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('a[href*="/products/"]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];

      if (!link.querySelector('img')) continue;
      if (link.closest(BLOCKED)) continue;

      var card = productCard(link);
      if (!card) continue;
      if (card.getAttribute('data-wishlist-card') === 'true') continue;

      card.setAttribute('data-wishlist-card', 'true');
      if (card.querySelector('[data-wishlist-toggle]')) continue;

      var handle = handleFromHref(link.getAttribute('href'));
      if (!handle) continue;

      var anchor = anchorFor(link, card);
      if (window.getComputedStyle(anchor).position === 'static') {
        anchor.style.position = 'relative';
      }
      anchor.appendChild(buildButton({ id: '', handle: handle }));
    }
  }

  function refresh(root) { autoInject(root); hydrate(root); }

  /* ---------------- events ---------------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var p = productFromButton(btn);
    if (!p.id && !p.handle) return;
    toggleWishlist(p);
  }, false);

  document.addEventListener(EVENT, function () { hydrate(document); });

  window.addEventListener('storage', function (e) { if (e.key === KEY) hydrate(document); });

  var pending = null;
  var observer = new MutationObserver(function (mutations) {
    var relevant = false;
    for (var i = 0; i < mutations.length && !relevant; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.querySelector && n.querySelector('a[href*="/products/"]')) { relevant = true; break; }
      }
    }
    if (!relevant) return;
    if (pending) window.clearTimeout(pending);
    pending = window.setTimeout(function () { refresh(document); }, 120);
  });

  function start() {
    refresh(document);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { refresh(document); }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }

  document.addEventListener('shopify:section:load', function (e) { refresh(e.target || document); });

  /* ---------------- <wishlist-button> element ---------------- */

  if (!window.customElements.get('wishlist-button')) {
    var WishlistButton = function () { return Reflect.construct(HTMLElement, [], WishlistButton); };
    WishlistButton.prototype = Object.create(HTMLElement.prototype);
    WishlistButton.prototype.constructor = WishlistButton;
    Object.setPrototypeOf(WishlistButton, HTMLElement);

    WishlistButton.prototype.connectedCallback = function () {
      if (this.getAttribute('data-wishlist-ready') === 'true') return;
      this.setAttribute('data-wishlist-ready', 'true');
      var p = {
        id: this.getAttribute('product-id') || this.getAttribute('data-product-id') || '',
        handle: this.getAttribute('product-handle') || this.getAttribute('data-product-handle') || ''
      };
      if (!p.id && !p.handle) return;
      var btn = buildButton(p);
      this.innerHTML = '';
      this.appendChild(btn);
      paintButton(btn, read());
    };

    window.customElements.define('wishlist-button', WishlistButton);
  }

  /* ---------------- expose ---------------- */

  window.Wishlist8com = {
    getWishlist: getWishlist,
    isWishlisted: isWishlisted,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    toggleWishlist: toggleWishlist,
    updateWishlistButtons: hydrate,
    updateWishlistCount: updateCount,
    refresh: refresh,
    count: count,
    clear: clear,
    STORAGE_KEY: KEY,
    EVENT: EVENT
  };
})();
